import { render, staticRenderFns } from "./RemovedResources.vue?vue&type=template&id=34d8a0b1&scoped=true"
import script from "./RemovedResources.vue?vue&type=script&lang=js"
export * from "./RemovedResources.vue?vue&type=script&lang=js"
import style0 from "./RemovedResources.vue?vue&type=style&index=0&id=34d8a0b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d8a0b1",
  null
  
)

export default component.exports